<template>
  <div class="d-inline">
    <a href="#" @click.prevent="openModal()">View PDF</a>
    <modal v-if="modalOpen" @close="modalOpen = false">
      <template #body>
          <div class="content">
              <div class="home_wrap">
                  <PdfViewer :pdfurl="pdfurl"></PdfViewer>
              </div>
          </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./ModalFullScreen.vue";
import PdfViewer from "./PdfViewer.vue";

export default {
  name: "PdfViewerModal",
  components: {Modal, PdfViewer},
  data(){
    return{
        modalOpen: false,
    }
  },
  props: {
    pdfurl: {
      type: String,
    },
  },
  methods: {
      openModal() {
          this.modalOpen = true;
      },
  }
}
</script>

<style lang="scss" scoped>
.home_wrap{
  width: 100%;
  height: 100%;
}
</style>